/**
 * Parses an RFC 4180 CSV string into rows of fields.
 * Supports quoted fields (with embedded commas, escaped quotes `""`, and newlines),
 * CRLF line endings, and a leading UTF-8 BOM. Entirely-empty rows are skipped.
 * Throws on malformed input (unterminated quotes, stray quotes after a quoted field).
 */
export function parseCsv(csvText) {
    let text = csvText;
    if (text.charCodeAt(0) === 0xfeff) {
        text = text.slice(1);
    }
    const rows = [];
    let row = [];
    let field = '';
    let fieldWasQuoted = false;
    let insideQuotes = false;
    let index = 0;
    function endField() {
        row.push(field);
        field = '';
        fieldWasQuoted = false;
    }
    function endRow() {
        endField();
        const rowIsEmpty = row.length === 1 && row[0] === '';
        if (!rowIsEmpty) {
            rows.push(row);
        }
        row = [];
    }
    while (index < text.length) {
        const char = text[index];
        if (insideQuotes) {
            if (char === '"') {
                if (text[index + 1] === '"') {
                    field += '"';
                    index += 2;
                }
                else {
                    insideQuotes = false;
                    index += 1;
                }
            }
            else {
                field += char;
                index += 1;
            }
            continue;
        }
        switch (char) {
            case '"':
                if (field === '' && !fieldWasQuoted) {
                    insideQuotes = true;
                    fieldWasQuoted = true;
                }
                else if (fieldWasQuoted) {
                    throw new Error(`Unexpected quote after a closed quoted field at position ${index}`);
                }
                else {
                    // A quote in the middle of an unquoted field is treated literally.
                    field += char;
                }
                index += 1;
                break;
            case ',':
                endField();
                index += 1;
                break;
            case '\r':
                if (text[index + 1] === '\n') {
                    index += 1;
                }
                endRow();
                index += 1;
                break;
            case '\n':
                endRow();
                index += 1;
                break;
            default:
                if (fieldWasQuoted && char !== ' ') {
                    throw new Error(`Unexpected quote after a closed quoted field at position ${index}`);
                }
                field += char;
                index += 1;
        }
    }
    if (insideQuotes) {
        throw new Error('Unterminated quoted field in CSV input');
    }
    if (field !== '' || fieldWasQuoted || row.length) {
        endRow();
    }
    return rows;
}
//# sourceMappingURL=csv_helper.js.map